import { array, number, object, string, TypeOf } from 'zod';

/* --------------------------- SubscriptionIntent --------------------------- */

export const SubscriptionIntent = object({
    clientSecret: string(),
    items: array(string()),
});
export type SubscriptionIntent = TypeOf<typeof SubscriptionIntent>;

/* ---------------------------- SubscriptionCard ---------------------------- */

export const SubscriptionCard = object({
    brand: string(),
    lastFourDigits: string(),
    expiryMonth: number(),
    expiryYear: number()
});
export type SubscriptionCard = TypeOf<typeof SubscriptionCard>;

/* ---------------------------- SubscriptionPaymentMethod ---------------------------- */

export const SubscriptionPaymentMethod = object({
    created: string(),
    type: string(),
    card: SubscriptionCard.optional()
});
export type SubscriptionPaymentMethod = TypeOf<typeof SubscriptionPaymentMethod>;

/* ----------------------------- UpdateCardIntent ---------------------------- */

export const UpdateCardIntent = object({
    clientSecret: string(),
});
export type UpdateCardIntent = TypeOf<typeof UpdateCardIntent>;

/* -------------------------- RequiresActionIntent -------------------------- */

export const RequiresActionIntent = object({
    clientSecret: string(),
});
export type RequiresActionIntent = TypeOf<typeof RequiresActionIntent>;
